import React, { useState, useMemo } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import get from 'lodash/get'

import { Form, Checkbox, Select } from 'components/forms'
import { ImageUploaderGraphql, UploaderComponent, StyledContainerNoDimensions } from 'components/Image'
import { ContentBlock } from 'components/ContentBlock'
import listCategories from 'sections/category/gql/listCategories'
import { getCCItem, updateCCItem } from '../gql'
import query from '../gql/getCategory'
import { useQuery, useMutation } from 'components/graphql'
import getPriceLevels from 'config/localServer/query/priceLevelsQuery'


const Options = ({ data, formData, itemId, mutations: { updateItem } }) => {
	const [isUploadingCC, setIsUploadingCC] = useState()
	const [t] = useTranslation()
	const imgKey = get(data, 'img.key', '')
	const { data: priceLevelsData, queryField } = useQuery(getPriceLevels)
	const priceLevels = get(priceLevelsData, [queryField], []).map((name, i) => ({ value: (i + 1), label: name }))
	const { data: ccData, queryField: ccQueryField } = useQuery(getCCItem, { variables: { categoryId: itemId } })
	const idCC = useMemo(() => ccData?.[ccQueryField]?.id, [ccData])
	const ccImgUrl = ccData?.[ccQueryField]?.categoryImgs?.[0]?.imgUrl

	const [mutateCCItem] = useMutation(updateCCItem, {
		onCompleted: () => {
			if(isUploadingCC) {
				setIsUploadingCC(false)
			}
		}
	})
	const handleUploadCC = file => {
		setIsUploadingCC(true)
		const reader = new FileReader()

		reader.readAsDataURL(file)
		reader.onload = () => {
			mutateCCItem({
				variables: {
					id: idCC,
					categoryId: itemId,
					categoryImgs: { id: itemId, img: reader.result }
				}
			})
		}
	}
	const handleDelCC = () => {
		setIsUploadingCC(true)
		mutateCCItem({
			variables: {
				id: idCC,
				categoryId: itemId,
				categoryImgs: { id: itemId, img: null }
			}
		})
	}

	return(
		<ContentBlock>
			<Form
				smartSubmit
				initialValues={formData}
				onSubmit={updateItem}
				render={() => (
					<Row>
						<Col xs>
							<Select
								label={t('category_section.fields.price_level')}
								field='priceLevel'
								options={[
									{ value: 0, label: `<${t('category_section.strings.price_level_standard')}>` },
									...priceLevels,
									{ value: 99, label: t('category_section.strings.price_level_null') }
								]}
							/>
							<Select
								label={t('category_section.fields.link_category')}
								field='categoryId'
								withVirtualBody
								valueField='id'
								labelField='name'
								isClearable
								isSearchable
								remoteOptions={{
									query: listCategories,
									variables: { params: { limit: 50 } },
									modifyOptions: options => options.filter(({ id }) => id !== data.id)
								}}
							/>
							<Checkbox field='isNoAction' label={t('category_section.fields.template_no_action')}/>
							<Checkbox field='isActiveInHouse' label={t('category_section.fields.is_active_in_house')}/>
						</Col>
						<Col xs>
							<ImageUploaderGraphql
								id={itemId}
								getQuery={query}
								type='Category'
								imgKey={imgKey}
								label={t('common.fields.image')}
								width={800}
								height={800}
							/>
						</Col>
						<Col xs>
							<StyledContainerNoDimensions hasImg={!!ccImgUrl}>
								<UploaderComponent
									src={ccImgUrl}
									label={t('category_section.strings.click_collect_category_img')}
									handleUpload={handleUploadCC}
									handleDelete={handleDelCC}
									width={288}
									height={288}
									isUploading={isUploadingCC}
								/>
							</StyledContainerNoDimensions>
						</Col>
					</Row>
				)}/>
		</ContentBlock>
	)
}

export default Options

